// src/components/PatronHtmlParser.tsx
import React, { useEffect, useState } from "react";

type PatronData = {
  [key: string]: string;
};

const PatronHtmlParser: React.FC = () => {
  const [patronData, setPatronData] = useState<PatronData>({});
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAndParseHtml = async () => {
      try {
        const response = await fetch(
          "http://stlow.iii.com:4500/PATRONAPI/D100000025/dump"
        ); // Update with your real endpoint
        if (!response.ok) throw new Error(`HTTP error ${response.status}`);

        const htmlString = await response.text();
        // console.log("Fetched HTML:", htmlString);

        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        const bodyText = doc.body.innerHTML;

        // Split by <br> or <BR>
        const lines = bodyText
          .split(/<br\s*\/?>/i)
          .map((line) => line.trim())
          .filter(Boolean);

        const parsedData: PatronData = {};

        lines.forEach((line) => {
          const match = line.match(/^(.+?)\[[^\]]+\]=(.+)$/);
          if (match) {
            const key = match[1].trim();
            const value = match[2].trim();
            parsedData[key] = value;
          }
        });

        setPatronData(parsedData);
      } catch (err) {
        setError((err as Error).message);
      }
    };

    fetchAndParseHtml();
  }, []);

  if (error) return <p>Error: {error}</p>;

  return (
    <div style={{ padding: "20px" }}>
      <h2>Patron Information</h2>
      {Object.keys(patronData).length === 0 ? (
        <p>Loading data...</p>
      ) : (
        <table style={{ borderCollapse: "collapse", width: "100%" }}>
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  padding: "8px",
                  borderBottom: "1px solid #ccc",
                }}
              >
                Field
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "8px",
                  borderBottom: "1px solid #ccc",
                }}
              >
                Value
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(patronData).map(([key, value]) => (
              <tr key={key}>
                <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                  {key}
                </td>
                <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                  {value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PatronHtmlParser;
